var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bases-list" },
    [
      _vm._m(0),
      _vm._l(_vm.schoolData, function (base, index) {
        return _c("div", { key: index, staticClass: "base-item" }, [
          _c("p", [_vm._v(_vm._s(base.year))]),
          _c("p", [_vm._v(_vm._s(base.spnameNew || "-"))]),
          _c("p", [_vm._v(_vm._s(base.subjectName || "-"))]),
          _c("p", [_vm._v(_vm._s(base.num || "-"))]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "bases-list-header" }, [
      _c("li", [_vm._v("年份")]),
      _c("li", [_vm._v("专业")]),
      _c("li", [_vm._v("学位门类")]),
      _c("li", [_vm._v("招生人数")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }